import { rewardCategories } from '../../learnware/GlobalConstants';
export class UserStore {
    parent;
    constructor(parent) {
        this.parent = parent;
    }
    get user() {
        return this.parent;
    }
    get userDataStore() {
        return this.user.userData.userStore;
    }
    get showGrade() {
        if (typeof this.userDataStore.showGrade === 'undefined')
            return 1;
        return this.userDataStore.showGrade;
    }
    set showGrade(n) {
        this.userDataStore.showGrade = n;
    }
    get sendManually() {
        return this.userDataStore.sendManually || 0;
    }
    set sendManually(n) {
        this.userDataStore.sendManually = n;
    }
    get numberOfQuestionsPerCycle() {
        return this.userDataStore.numberOfQuestionsPerCycle || 20;
    }
    set numberOfQuestionsPerCycle(n) {
        this.userDataStore.numberOfQuestionsPerCycle = n;
    }
    get showRewardOnCycleEnd() {
        if (typeof this.userDataStore.showRewardOnCycleEnd === 'undefined')
            return true;
        return this.userDataStore.showRewardOnCycleEnd;
    }
    set showRewardOnCycleEnd(b) {
        this.userDataStore.showRewardOnCycleEnd = b;
    }
    get blockedRewardCategories() {
        return this.userDataStore.blockedRewardCategories || [];
    }
    set blockedRewardCategories(b) {
        this.userDataStore.blockedRewardCategories = b;
    }
    get rewardCategories() {
        if (!this.showRewardOnCycleEnd)
            return [];
        return Object.keys(rewardCategories).filter(c => !this.blockedRewardCategories.includes(c));
    }
    set rewardCategories(b) {
        this.userDataStore.rewardCategories = b;
    }
    get isSpeakerMuted() {
        return this.userDataStore.isSpeakerMuted || false;
    }
    set isSpeakerMuted(b) {
        this.userDataStore.isSpeakerMuted = b;
    }
}
